import * as React from 'react';
import classnames from 'classnames';
import { useFormatter } from '@grandvisionhq/frk-routing';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { Navigation } from './Navigation.js';

const NavigationContainer = ({ currentStep , disabledSteps , isLoggedIn  })=>{
    const query = new URLSearchParams(window.location.search);
    const checkoutSettings = useCheckoutSettings();
    var _routes;
    const routes = (_routes = checkoutSettings.routes) !== null && _routes !== void 0 ? _routes : {};
    const formatter = useFormatter();
    const navigationRoutes = Object.entries(routes).filter(([key])=>key !== 'callback' && key !== 'completed'
    );
    return /*#__PURE__*/ React.createElement("nav", {
        className: "checkout-nav"
    }, navigationRoutes.map(([step, route], index)=>{
        const href = formatter({
            route: `checkout.${step}`,
            query
        });
        const currentStepIndex = Object.keys(routes).indexOf(currentStep);
        const isDisabled = index > currentStepIndex || disabledSteps && disabledSteps.includes(step);
        const classNames = classnames('checkout-nav-step', {
            'checkout-nav-step--active': step === currentStep,
            'checkout-nav-step--disabled': isDisabled,
            'checkout-nav-step--completed': index < currentStepIndex && !isDisabled
        });
        return /*#__PURE__*/ React.createElement(Navigation, {
            href: href,
            classNames: classNames,
            index: index,
            isLoggedIn: isLoggedIn,
            key: step,
            route: route,
            isDisabled: isDisabled
        });
    }));
};

export { NavigationContainer };
//# sourceMappingURL=NavigationContainer.js.map
